import { createTheme } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';


/* 
    Create form theme
*/
const FormTheme = createTheme({
  typography: {
    fontFamily: '"Kumbh Sans", "Roboto", "Helvetica", "Arial", sans-serif'
  },
  palette: {
    primary: {
      main: blue["500"]
    }
  },
  element: {
    fontFamily: '"Kumbh Sans", "Roboto", "Helvetica", "Arial", sans-serif'
  }

})

export default FormTheme;